import "./hover-label--split";



// WEBPACK FOOTER //
// ./client/src/core/components/hover-label/index.js